import type { RefObject } from "react";

import type { OpenAPI } from "simplydo/interfaces";

import IdeaSidebar from "components/ideas/IdeaSidebar/IdeaSidebar";
import type { ItemRefs } from "components/ideas/useIdeaScrollTracking";

type IdeaAssessmentProps = {
  idea: OpenAPI.Assign<
    OpenAPI.Schemas["Idea"],
    OpenAPI.Schemas["AssignIdeaChallenges"],
    OpenAPI.Schemas["AssignIdeaSubmissibilityStatus"],
    OpenAPI.Schemas["AssignIdeaTemplates"]
  >;
  assessment?: NonNullable<OpenAPI.Schemas["Idea"]["assessments"]>[number];
  sectionRefs?: RefObject<ItemRefs>;
  fieldRefs?: RefObject<ItemRefs>;
  scrollRef?: RefObject<HTMLDivElement | null>;
};

export const IdeaAssessment = ({
  idea,
  sectionRefs,
  fieldRefs,
  scrollRef,
}: IdeaAssessmentProps) => {
  return (
    <div style={{ display: "flex" }}>
      <IdeaSidebar
        idea={idea}
        sectionRefs={sectionRefs}
        fieldRefs={fieldRefs}
        scrollRef={scrollRef}
        isEditing={false}
      />
    </div>
  );
};
